import styled from 'styled-components';

const Container = styled.div<{
  $width: number;
  $height: number;
  $maxWidth: number;
}>`
  position: relative;
  max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
  width: 100%;
  aspect-ratio: ${({ $width, $height }) => `${$width} / ${$height}`};
`;

const Wrapper = styled.div<{
  $width: number;
  $height: number;
  $maxWidth: number;
  $isAllImagesLoaded: boolean;
  $tilt: boolean;
}>`
  position: relative;
  max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
  width: 100%;
  aspect-ratio: ${({ $width, $height }) => `${$width} / ${$height}`};

  visibility: ${({ $isAllImagesLoaded }) => ($isAllImagesLoaded ? 'visible' : 'hidden')};

  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  transition: all 0.3s ease;
  will-change: transform;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version */
  -webkit-tap-highlight-color: transparent;
  touch-action: none; /* 터치 동작 제어 */

  /* PC 환경 */
  @media (hover: hover) {
    cursor: pointer;
    &:hover {
      transform: ${({ $tilt }) =>
        $tilt
          ? 'perspective(1000px) rotateX(var(--rotate-x, 0deg)) rotateY(var(--rotate-y, 0deg)) scale(1.02)'
          : 'none'};
    }
  }

  /* 모바일 환경 */
  @media (hover: none) {
    cursor: pointer;
    transform: ${({ $tilt }) =>
      $tilt ? 'perspective(1000px) rotateX(var(--rotate-x, 0deg)) rotateY(var(--rotate-y, 0deg)) scale(1.02)' : 'none'};
  }
`;

const DigitalCardFace = styled.div<{
  $isInteracting: boolean;
  $position: 'prev' | 'current' | 'next';
}>`
  position: absolute;
  width: 100%;
  height: 100%;

  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  transition: transform 0.6s;
  will-change: transform;
  transform: ${({ $position }) => {
    switch ($position) {
      case 'prev':
        return 'rotateY(-180deg)';
      case 'next':
        return 'rotateY(180deg)';
      default:
        return 'rotateY(0)';
    }
  }};
`;

const LoadingContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 100;
`;

const ErrorContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #ffffff;
  z-index: 100;
`;

const DigitalCardStyled = {
  Container,
  Wrapper,
  DigitalCardFace,
  LoadingContainer,
  ErrorContainer,
};

export default DigitalCardStyled;
